import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent implements OnInit 
{
  type:string = "text";

  constructor(public dialogRef: MatDialogRef<InputDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { title: string | "title", detail:string | "detail", accept:string  | "accept", cancel:string  | "cancel", content:string | "content", type: "number" | "text"}) { }

  ngOnInit(): void 
  {
    this.type = this.data.type;
  }

  onCancel(): void 
  {
    this.dialogRef.close();
  }
}